<template>
  <Action :action="mappedAction" :completed="action.closed" @open-edit-component="pscClicked">
    <template #default>
      <!-- disable this rule to make sure that task content is exactly displayed -->
      <!-- eslint-disable-next-line vue/singleline-html-element-content-newline -->
      <div class="white-space-pre font-bold">{{ action.problem }}</div>
    </template>
    <!-- To prevent the default template to be rendered, we inject a Zero-Width-Space into the template -->
    <template #deadline>&#8203;</template>

    <template #status>
      <StatusCircleComponent style="height: 1.5rem" :status="action.status ?? 0" />
    </template>
    <template #editComponent>
      <PSCEdit
        v-if="PSCDialogVisible"
        :id="action.id"
        :show-in-modal="true"
        @update:visible-action-modal="PSCDialogVisible = $event"
      >
      </PSCEdit>
    </template>
  </Action>
</template>

<script setup lang="ts">
import { computed, type PropType, ref } from "vue";
import type { ActionListActionFields_PSC_Fragment, EventListEventFieldsFragment } from "@/graphql";
import Action from "../action/ActionComponent.vue";
import StatusCircleComponent from "../task/StatusCircleComponent.vue";
import PSCEdit from "@/modules/psc/views/PSCEdit.vue";

const props = defineProps({
  action: {
    type: Object as PropType<ActionListActionFields_PSC_Fragment>,
    required: true,
  },
  event: {
    type: Object as PropType<EventListEventFieldsFragment>,
    required: true,
  },
});
const PSCDialogVisible = ref(false);

const mappedAction = computed(() => ({
  ...props.action,
}));
const pscClicked = () => {
  PSCDialogVisible.value = true;
};
</script>

<style lang="scss" scoped></style>
